import { defineMessages } from 'react-intl-next';

export const messages: {
    initialsAvatarLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; personAvatarLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	personAvatarLabel: {
		id: 'personAvatar.label',
		defaultMessage: 'Person Avatar',
		description: 'Default person avatar icon for users in the Contributor or Owner filters in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
	initialsAvatarLabel: {
		id: 'initialsAvatar.label',
		defaultMessage: 'Initials Avatar',
		description: 'Avatar with user\'s initials in the Contributor or Owner filters in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
});
